export const CREATE_ROOM_REQUEST = "MeetingRoom/CREATE_ROOM_REQUEST";
export const CREATE_ROOM_SUCCESS = "MeetingRoom/CREATE_ROOM_SUCCESS";
export const CREATE_ROOM_FAIL = "MeetingRoom/CREATE_ROOM_FAIL";
export const CREATE_ROOM_RESET = "MeetingRoom/CREATE_ROOM_RESET";

export const GET_ROOM_BY_SLUG_REQUEST = "MeetingRoom/GET_ROOM_BY_SLUG_REQUEST";
export const GET_ROOM_BY_SLUG_SUCCESS = "MeetingRoom/GET_ROOM_BY_SLUG_SUCCESS";
export const GET_ROOM_BY_SLUG_FAIL = "MeetingRoom/GET_ROOM_BY_SLUG_FAIL";
export const GET_ROOM_BY_SLUG_RESET = "MeetingRoom/GET_ROOM_BY_SLUG_RESET";

export const GET_BOARD_ROOMS_REQUEST = "MeetingRoom/GET_BOARD_ROOMS_REQUEST";
export const GET_BOARD_ROOMS_SUCCESS = "MeetingRoom/GET_BOARD_ROOMS_SUCCESS";
export const GET_BOARD_ROOMS_FAIL = "MeetingRoom/GET_BOARD_ROOMS_FAIL";
